import { useMemo } from "react";
import type { TestCase } from "./types";

/**
 * Client-side filtering for test cases.
 * Note: Filter type (production/local/app config) is now handled server-side.
 * This hook only handles the showRejected filter.
 */
export const useTestCasesFiltering = (testCases: TestCase[], showRejected: boolean = false) => {
  const filteredTestCases = useMemo(() => {
    // Filter out rejected tests by default (unless showRejected is true)
    if (!showRejected) {
      return testCases.filter((testCase) => !testCase.tags?.includes("rejected"));
    }
    return testCases;
  }, [testCases, showRejected]);

  return { filteredTestCases };
};
